import { useState } from 'react';
import { SchedulingChangeRequestsRequest } from '../../../models/employees-portal/CreateSchedulingRequest';
import { RequestsManagementsAPI } from '../../../services/external/APIs/requests-managements/RequestsManagements';
import { CoveringsAPI } from '../../../services/external/APIs/coverings/Coverings.api';
import { CoverRequest } from '../../../models/coverings/CoverRequest';
import { CoverSchedulingByEmployeeAndDate } from '../models/coverScheduling';

export const useRequest = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const convertToFormData = (body: SchedulingChangeRequestsRequest): FormData => {
        const formData = new FormData();

        const appendField = (key: string, value: any) => {
            if (value !== null && value !== undefined && value !== '') {
                formData.append(key, value.toString());
            }
        };

        appendField('startDate', body.startDate);
        appendField('endDate', body.endDate);

        if (body.workshiftSchedulingChangeRequest) {
            appendField(
                'workshiftSchedulingChangeRequest.comments',
                body.workshiftSchedulingChangeRequest.comments
            );
            appendField(
                'workshiftSchedulingChangeRequest.workshiftId',
                body.workshiftSchedulingChangeRequest.workshiftId.toString()
            );
        }

        if (body.interruptionRequest) {
            appendField(
                'interruptionRequest.interruptionTypeId',
                body.interruptionRequest.interruptionTypeId.toString()
            );
            if (body.interruptionRequest.file) {
                formData.append(
                    'interruptionRequest.file',
                    body.interruptionRequest.file
                );
            }
            appendField(
                'interruptionRequest.startHour',
                body.interruptionRequest.startHour
            );
            appendField(
                'interruptionRequest.endHour',
                body.interruptionRequest.endHour
            );
            appendField(
                'interruptionRequest.comments',
                body.interruptionRequest.comments
            );
            appendField('interruptionRequest.date', body.interruptionRequest.date);
            appendField(
                'interruptionRequest.isFullDay',
                body.interruptionRequest.isFullDay.toString()
            );
        }

        return formData;
    };

    const createRequest = (request: SchedulingChangeRequestsRequest) => {
        setIsLoading(true);
        setErrorMessage(null);

        let body: SchedulingChangeRequestsRequest;

        body = {
            startDate: request.startDate,
            endDate: request.endDate,
            //@ts-ignore
            workshiftSchedulingChangeRequest:
                request.workshiftSchedulingChangeRequest.workshiftId > 0
                    ? request.workshiftSchedulingChangeRequest
                    : null,
            //@ts-ignore
            interruptionRequest:
                request.interruptionRequest.interruptionTypeId > 0
                    ? request.interruptionRequest
                    : null,
        };

        let bodyConverted = convertToFormData(body);

        return RequestsManagementsAPI.createSchedulingChangeRequests(bodyConverted)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                if (error.response && typeof error.response.data === 'string') {
                    setErrorMessage(error.response.data);
                } else {
                    setErrorMessage(`Ocurrió un error al crear la solicitud`);
                }
                throw error;
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const CreateCoverRequest = (
        coverRequest: CoverRequest,
        request: SchedulingChangeRequestsRequest,
        coverPerson: any,
        requestModalInfo: any,
        coverScheduling?: CoverSchedulingByEmployeeAndDate
    ) => {
        let body: CoverRequest = { ...coverRequest };

        if (coverPerson !== undefined && requestModalInfo?.info !== undefined) {
            body.date = request?.interruptionRequest.date + 'T00:00';
            body.coverCurrentWorkshiftId = coverScheduling?.workshiftId ?? null;
            body.coverCurrentInterruptionTypeId =
                coverScheduling?.interruptionTypeId ?? null;
            body.coverPersonId = coverPerson?.id;
            body.requesterCurrentInterruptionTypeId =
                requestModalInfo?.info?.interruptionTypeId;
            body.requesterCurrentWorkshiftId = requestModalInfo?.info?.workshiftId;
            body.personId = requestModalInfo?.info?.personId;
            body.compensationDate = coverRequest.compensationDate
                ? coverRequest.compensationDate + 'T00:00'
                : null;
        }

        return CoveringsAPI.create(body)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                throw error;
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return { isLoading, errorMessage, createRequest, CreateCoverRequest };
};
